export interface SubteamRow {
  key:     string;
  name:    string;
  members: number;
}

export const SUBTEAMS: SubteamRow[] = [
  { key: '1', name: 'Golf Course Road', members: 17 },
  { key: '2', name: 'Sushant Lok 1',    members: 10 },
];

export interface SubteamMember {
  key:         string;
  name:        string;
  email:       string;
  status:      string;
  permissions: string[];
}

export const SUBTEAM_MEMBERS: Record<string, SubteamMember[]> = {
  '1': [
    { key: 'm1', name: 'Amit Singh Dahiya', email: 'amit.d@fitclub.in',      status: 'Active', permissions: ['View clients assigned to subteam members', 'Create content visible to subteam'] },
    { key: 'm2', name: 'Garima Gaur',       email: 'garima.jauhar@gmail.com', status: 'Active', permissions: [] },
    { key: 'm3', name: 'Lakshay Makkar',    email: 'lakshay44m@gmail.com',    status: 'Active', permissions: [] },
    { key: 'm4', name: 'Lalit Kumar',       email: 'lalit@fitclub.in',        status: 'Active', permissions: [] },
    { key: 'm5', name: 'Pankaj Baweja',     email: 'pankaj@fitclub.in',       status: 'Active', permissions: [] },
    ...Array.from({ length: 12 }, (_, i) => ({
      key: `m${i + 6}`, name: `Team Member ${i + 6}`, email: `member${i + 6}@fitclub.in`, status: 'Active', permissions: [] as string[],
    })),
  ],
  '2': Array.from({ length: 10 }, (_, i) => ({
    key: `s${i + 1}`, name: `Team Member ${i + 1}`, email: `member${i + 1}@fitclub.in`, status: 'Active', permissions: [] as string[],
  })),
};

export interface TeamMemberOption {
  key:   string;
  name:  string;
  email: string;
}

// Full org roster used by the "Add Members to Subteam" picker.
export const ALL_TEAM_MEMBERS: TeamMemberOption[] = [
  { key: 'tm0', name: 'Fitclub',           email: 'saurabh@bellatorgroup.in' },
  { key: 'm1',  name: 'Amit Singh Dahiya', email: 'amit.d@fitclub.in' },
  { key: 'tm1', name: 'Ayushi',            email: 'ayushi.02603@gmail.com' },
  { key: 'tm2', name: 'Dhun',              email: 'dhunmehra17@gmail.com' },
  { key: 'm2',  name: 'Garima Gaur',       email: 'garima.jauhar@gmail.com' },
  { key: 'm3',  name: 'Lakshay Makkar',    email: 'lakshay44m@gmail.com' },
  { key: 'm4',  name: 'Lalit Kumar',       email: 'lalit@fitclub.in' },
  { key: 'tm3', name: 'Mohit Kumar',       email: 'bhagatmohit16@gmail.com' },
  { key: 'm5',  name: 'Pankaj Baweja',     email: 'pankaj@fitclub.in' },
  ...Array.from({ length: 12 }, (_, i) => ({
    key: `m${i + 6}`, name: `Team Member ${i + 6}`, email: `member${i + 6}@fitclub.in`,
  })),
  { key: 'tm4', name: 'Sushant Rana', email: 'sushant.rana@gmail.com' },
  { key: 'tm5', name: 'Priya Sharma', email: 'priya.sharma@gmail.com' },
];
